import * as React from 'react'
import { withFields } from '../../common/modules/fields'
import { withProductData } from '../../common/modules/product-data'
import { Table, Cell, Row, Alternate } from '../../common/components/summary-table'
import { find, pull } from 'lodash'
import { toCurrency } from '../../common/util'
import Select from 'react-select'
import StepBlock from '../../common/components/step-block'
import Description from '../../common/components/description'
import "./high-risk-items-editor.css"


@withFields
@withProductData
export default class extends React.Component<any, any>{

    private highRiskTtemType:Select;


    constructor(props){
        super(props)

        this.state = {
            editting: null,
            item: {}
        }
    }


    componentWillReceiveProps(){
        if(this.props.fields.specifiedItemData == null){
            this.props.actions.fields.updateField("specifiedItemData", [])
        }
    }


    submit(){
        console.log("Submit")
        const specifiedItemData = this.props.fields.specifiedItemData ? this.props.fields.specifiedItemData.slice(0) : [];
        const item = this.state.item;

        const options = this.props.productData.productOptions.SPECIFIED_ITEM_TYPE;
        const label = find( options, option => option.value == item.code).label

        if(this.isNewItem()){
            specifiedItemData.push({
                ...item,
                portable: false, // This is hardcoded as it is a legacy field
                type: label
            });
        }else{
            const index = this.props.fields.specifiedItemData.indexOf( this.state.editting );
            specifiedItemData[index].code = item.code;
            specifiedItemData[index].description = item.description;
            specifiedItemData[index].value = item.value;
            specifiedItemData[index].type = label;
            specifiedItemData[index].portable = false; // This is hardcoded as it is a legacy field
        }

        this.props.actions.fields.updateField("specifiedItemData", specifiedItemData)
        this.clear();
    }


    clear(){
        this.setState({
            editting:null,
            item:{}
        })
    }


    isNewItem(){
        return this.state.editting == null
    }


    onTypeChange(e){
        console.log("Type change: ")
        console.log(e)
        this.setState({
            ...this.state,
            item:{
                ...this.state.item,
                code: e.value
            }
        })
    }


    onEdit(item){
        console.log("Edit item: ")
        console.log(item)
        this.setState({
            item:{
                ...item
            },
            editting: item
        })
        this.highRiskTtemType.focus();
    }


    onDelete(item){
        console.log("Delete item: ")
        console.log(item)

        const specifiedItemData = pull( this.props.fields.specifiedItemData, item)
        this.props.actions.fields.updateField("specifiedItemData", specifiedItemData)
        if(this.state.editting === item) this.clear();
    }


    onDescriptionChange(e){
        this.setState({
            ...this.state,
            item:{
                ...this.state.item,
                description: e.target.value
            }
        })
    }

    onValueChange(e){
        this.setState({
            ...this.state,
            item:{
                ...this.state.item,
                value: e.target.value
            }
        })
    }


    itemIsValid(){
        const item = this.state.item
        return item.code && item.description && item.value
    }


    render(){
        const fields = this.props.fields
        const item = this.state.item
        const options = this.props.productData.productOptions.SPECIFIED_ITEM_TYPE

        if(fields.specifiedItemCover){
            return (
                <div className="high-risk-items">
                    <StepBlock>
                    <Description description={<b><i className="fa fa-info-circle"></i> Please add at least one high risk item by clicking the Add item button below.</b>} />
                    </StepBlock>
                    <div className="col-12 mb-3">
                        <div className="row">
                            <div className="col-md-4">
                                <label htmlFor="high-risk-item-type">Type</label>
                                <Select 
                                    name="high-risk-item-type"
                                    id="high-risk-item-type"
                                    ref={ ref => this.highRiskTtemType = ref } 
                                    value={ item.code }
                                    multi={ false }
                                    clearable={ false }
                                    searchable={ false }
                                    options={ options }
                                    onChange={ this.onTypeChange.bind(this) }
                                />
                            </div>
                            <div className="hacky-spacer col-12 mb-2 hidden-md-up"></div>
                            <div className="col-8 col-md-5">
                                <label htmlFor="high-risk-item-description">Description</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="high-risk-item-description"
                                    id="high-risk-item-description" 
                                    value={ this.state.item.description ||  "" } 
                                    onChange={ this.onDescriptionChange.bind(this) }  
                                />
                            </div>
                            <div className="col-4 col-md-3 text-md-right">
                                <label htmlFor="high-risk-item-value">Value</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="high-risk-item-value"
                                    id="high-risk-item-value"
                                    value={ this.state.item.value || "" }
                                    onChange={ this.onValueChange.bind(this) }  
                                />
                            </div>
                            <div className="col-12 mt-3">
                                { this.isNewItem() ? <button className="btn btn-primary" disabled={ !this.itemIsValid() } onClick={ this.submit.bind(this) }><i className="fa fa-arrow-down mr-1"></i> Add item</button> : null }
                                { this.isNewItem() == false ? <button className="btn btn-primary" disabled={ !this.itemIsValid() } onClick={ this.submit.bind(this) }>Save</button> : null }
                                { this.isNewItem() == false ? <button className="btn btn-primary ml-2"  onClick={ this.clear.bind(this) }>Cancel</button> : null }
                            </div>
                        </div>
                    </div>  
                    <Table riskItemTable>
                        <Row asHeading>
                            <Cell>Type</Cell>
                            <Cell>Description</Cell>
                            <Cell>Value</Cell>
                            <Cell className="edit-cell"></Cell>
                        </Row>
                        { (fields.specifiedItemData && fields.specifiedItemData.length>0) ? fields.specifiedItemData.map(item => (
                            <Row>
                                <Cell>{ find( options, option => option.value == item.code).label }</Cell>
                                <Cell>{ item.description }</Cell>
                                <Cell>{ "$" + toCurrency(item.value) }</Cell>
                                <Cell className="edit-cell"><button className="icon-button mr-2" onClick={ e => this.onEdit(item) }><i className="fa fa-pencil little-button"></i></button><button className="icon-button" onClick={ e => this.onDelete(item) }><i className="fa fa-trash little-button"></i></button></Cell>
                            </Row>
                        )) : 
                            <Row>
                                <Cell>---</Cell>
                                <Cell>---</Cell>
                                <Cell>---</Cell>
                                <Cell className="edit-cell"></Cell>
                            </Row>
                        }
                    </Table>
                </div>
            ) 
        }else{
            return null;
        }
    }

}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/contents/components/high-risk-items-editor.tsx